import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
const SHOPIFY_SUPPORT_URL = 'https://help.shopify.com/en/questions';
const SHOPIFY_PLANS_URL = 'https://shopify.com/pricing';
const SHOPIFY_ARTICLE_URL =
  'https://help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/enabling-shipping-carriers';
@Component({
  selector: 'third-party-enabled',
  templateUrl: './third-party-enabled.component.html',
  styleUrls: ['./third-party-enabled.component.scss'],
  standalone: false,
})
export class ThirdPartyEnabledComponent implements OnInit, OnDestroy {
  SHOPIFY_ARTICLE_URL = SHOPIFY_ARTICLE_URL;
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnDestroy() {}

  ngOnInit() {}

  onReviewShopifyPlans() {
    window.open(SHOPIFY_PLANS_URL, '_blank');
  }

  onChatWithShopify() {
    window.open(SHOPIFY_SUPPORT_URL, '_blank');
  }
}
